import React from "react";
import Select from "react-select";

const customStyles = {
  option: (provided) => ({
    ...provided,
    backgroundColor: "#1E1F43",
    cursor: "pointer",
    color: "#F8F8F8",
    fontSize: "14px",
    fontWeight: "500",
    display: "flex",
    height: "40px",
    padding: "11px 25px 12px 15px",
    alignItems: "center",
    alignSelf: "stretch",
    borderBottom: "1px solid rgba(255, 255, 255, 0.10)"
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#1E1F43",
    zIndex: 15
  }),
  control: (provided) => ({
    ...provided,
    display: "flex",
    padding: "0px 5px",
    justifyContent: "center",
    alignItems: "center",
    gap: "6px",
    borderRadius: "5px",
    border: "1px solid #ABB4F4",
    background: "#DCE0FC",
    color: "#000",
    fontFamily: "Rubik",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal"
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#000"
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#1E22FF",
    "&:hover": {
      color: "#1E22FF"
    }
  })
};

const options = [
  { value: "recommendations", label: "Recommendations" },
  { value: "mediaLibrary", label: "Media library" },
  { value: "recentUploads", label: "Recent uploads" }
];

const EditionOptionSelect = ({ emitOptionSelected, optionSelected }) => {
  const currentValue = options.filter((option) => option.value === optionSelected);

  return (
    <Select
      defaultValue={options[0]}
      options={options}
      styles={customStyles}
      onChange={emitOptionSelected}
      value={currentValue}
    />
  );
};

export default EditionOptionSelect;
